function injectStyle (ssrContext) {
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-3b059196\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Login.vue")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Login.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3b059196\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Login.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b059196",
  /* moduleIdentifier (server only) */
  null
)

/* customBlocks */
var customBlock = require("!!@kazupon/vue-i18n-loader!../../static/localization/login.json")
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Login.vue
// module id = 209
// module chunks = 1